import { useMemo } from "react";
import getProductStatus from "components/Pages/Finance/_hook/getProductStatus";

export default (financialProductObj) => {
  const destTimestamp = useMemo(() => {
    const status = getProductStatus(financialProductObj);
    if (status.reason === "soldOut") return;
    const { productType, financeProductStatus, subscribeStartTime, subscribeEndTime, workStartTime, workEndTime } = financialProductObj;
    //限时抢购：预热中显示产品开始申购倒计时；申购中显示申购结束倒计时
    if (productType === "RUSH") {
      if (financeProductStatus === "WARMING") {
        return subscribeStartTime;
      } else if (financeProductStatus === "SUBSCRIBING") {
        return subscribeEndTime;
      }
    }
    //新币挖矿：预热中显示开始预申购倒计时；预申购显示产品开始倒计时；运行中显示产品结束倒计时
    else if (productType === "LAUNCH_POOL") {
      if (financeProductStatus === "WARMING") {
        return subscribeStartTime;
      } else if (financeProductStatus === "PRE_SUBSCRIBING") {
        return workStartTime;
      } else if (financeProductStatus === "MINING") {
        return workEndTime;
      }
    }
    //云算力：预热中显示产品开始申购倒计时；申购中显示认购结束倒计时
    else if (productType === "HASH_RATE") {
      if (financeProductStatus === "WARMING") {
        return subscribeStartTime;
      } else if (financeProductStatus === "SUBSCRIBING") {
        return subscribeEndTime;
      }
    }
    //理财宝：定期、活期，质押挖矿-PoS质押，如果在预热中，显示倒计时
    else if (/^(TIME_SAVING|DEMAND_SAVING|POS_STAKING)$/.test(productType)) {
      if (financeProductStatus === "WARMING" && workStartTime) {
        return workStartTime;
      }
    }
  }, [financialProductObj]);

  return destTimestamp;
};
